import React from 'react'
import './resultsNotFound.css'
import imageOfNotResultsFound from '../../assets/Images/results_not_found_img.svg'
import imageOfNotRecordsFound from '../../assets/Images/results_not_records_found_img.svg'

export const ResultsNotFound = () => {
    return (
        <div className='results-not-found-cont'>
            <section>
                <img src={imageOfNotRecordsFound} alt="" />
            </section>
            <section>
                <h2>No Records Found</h2>
                <p>It looks like no entries have been created yet. To get started, click the button above and add your first entry, or wait for more to be added.</p>
            </section>
        </div>
    )
}
